
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("v1jQ6", function(module, exports) {

$parcel$export(module.exports, "EditorMovePageButtonLoader", () => $163bb5cb9a2af796$export$bb4636d2bf564dee);

var $5RlDR = parcelRequire("5RlDR");
const $163bb5cb9a2af796$export$bb4636d2bf564dee = (0, $5RlDR.EditorMovePageButton);

});
parcelRegister("5RlDR", function(module, exports) {

$parcel$export(module.exports, "EditorMovePageButton", () => $34016fb8fb167321$export$65b66e3b59bd4f0);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $dAYOx = parcelRequire("dAYOx");

var $3gadb = parcelRequire("3gadb");

var $4KS7f = parcelRequire("4KS7f");

var $inPa6 = parcelRequire("inPa6");

var $bbp3G = parcelRequire("bbp3G");

var $dIouf = parcelRequire("dIouf");

var $bHd1w = parcelRequire("bHd1w");

var $78wUU = parcelRequire("78wUU");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $fcURH = parcelRequire("fcURH");
const $34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs = ({ spaceKey: spaceKey, contentId: contentId, appearance: appearance = 'dropdownItem', analyticsSource: analyticsSource, dialogs: dialogs, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isUnpublishedDraft: isUnpublishedDraft })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)((0, $d2LG0.default)`query EditorMovePageButtonQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id type status operations{operation targetType}}}}`, {
        variables: {
            contentId: contentId
        },
        displayName: 'EditorMovePageButtonQuery'
    });
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    if (loading) return null;
    const content = data?.content?.nodes?.[0];
    const contentType = content?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const canMoveContent = isUnpublishedDraft || contentType === 'page' || !!operations.find((op)=>op?.targetType === contentType && op?.operation === 'delete');
    const openMoveModal = ()=>{
        if (contentType === 'page') {
            experienceTracker.start({
                name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
            });
            dialogs.showModal((0, $bHd1w.MovePageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                isMovingDraftVersion: true,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'page'
                }
            }).fire();
        } else if (contentType === 'blogpost') {
            dialogs.showModal((0, $78wUU.MoveBlogModalLoader), {
                currentSpaceKey: spaceKey,
                blogPostId: contentId,
                isEditMode: true,
                isUnpublishedDraft: isUnpublishedDraft,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'blog'
                }
            }).fire();
        }
    };
    let component;
    // if FF is on we should show move button for both blog and page types and for both publish and unpublish states
    if (canMoveContent || isUnpublishedDraft && contentType === 'page') {
        if (appearance === 'iconButton') {
            const icon = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                className: "icon aui-icon aui-icon-small aui-iconfont-nav-children"
            });
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                tag: "span",
                content: intl.formatMessage((0, $fcURH.i18n).movePageBtnDesc)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
                testId: "move-page-icon-button",
                iconBefore: icon,
                appearance: "subtle",
                onClick: openMoveModal
            }));
        } else if (appearance === 'dropdownItem') component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            onClick: openMoveModal,
            testId: "move-page-dropdown-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $fcURH.i18n).movePageBtnDesc));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "move-page-button"
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }), component);
};
const $34016fb8fb167321$export$65b66e3b59bd4f0 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bbp3G.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs, {
            ...props,
            dialogs: dialogs
        }));
};

});
parcelRegister("fcURH", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $0ac47e05aff110d2$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $0ac47e05aff110d2$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    movePageBtnDesc: {
        id: "editor-move-page-button.move.page.description",
        defaultMessage: "Move"
    }
});

});



parcelRegister("k0pnk", function(module, exports) {

$parcel$export(module.exports, "EditLabelDropdownItem", () => $bb6d2606da8fa2b2$export$207a057b55bce66d);

var $gwFzn = parcelRequire("gwFzn");

var $dAYOx = parcelRequire("dAYOx");

var $88KVZ = parcelRequire("88KVZ");

var $4vaoM = parcelRequire("4vaoM");
const $bb6d2606da8fa2b2$export$207a057b55bce66d = ({ contentId: contentId, spaceKey: spaceKey, dialogs: dialogs })=>{
    const buttonText = (0, $88KVZ.useLabelsDescriptionText)({
        contentId: contentId
    });
    const showEditLabelDialog = ()=>{
        const dialogProps = {
            contentId: contentId,
            spaceKey: spaceKey,
            source: 'fabricEditor'
        };
        dialogs.showModal((0, $4vaoM.EditLabelDialogLoader), dialogProps);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "edit-labels",
        onClick: showEditLabelDialog
    }, buttonText);
};

});

parcelRegister("5SlMo", function(module, exports) {

$parcel$export(module.exports, "CommonDropdownMenu", () => $79e94f3a61d46da4$export$6885a1ceb54a0bf4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $9VJDA = parcelRequire("9VJDA");

var $3gadb = parcelRequire("3gadb");
const $79e94f3a61d46da4$var$i18n = (0, $2nPZH.defineMessages)({
    moreActions: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more.actions.tooltip",
        defaultMessage: "More actions"
    }
});
const $79e94f3a61d46da4$export$6885a1ceb54a0bf4 = ({ isMenuOpen: isMenuOpen, handleMenuOpenChange: handleMenuOpenChange, children: children, testId: testId = 'ellipsis-dropdown-menu', isDisabled: isDisabled, tooltipDisabledState: tooltipDisabledState })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const disabledTooltipI18nObject = {
        id: tooltipDisabledState
    };
    const disabledTooltipText = tooltipDisabledState ? formatMessage(disabledTooltipI18nObject) : '';
    const tooltip = isDisabled ? disabledTooltipText : formatMessage($79e94f3a61d46da4$var$i18n.moreActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: isMenuOpen ? '' : tooltip,
        position: "bottom",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "ellipsis-dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
        placement: "bottom-end",
        testId: testId,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
                ...props,
                label: formatMessage($79e94f3a61d46da4$var$i18n.moreActions),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                isDisabled: isDisabled,
                appearance: "subtle"
            }),
        appearance: "tall",
        isOpen: isMenuOpen,
        onOpenChange: handleMenuOpenChange
    }, children)));
};

});

parcelRegister("6DX3n", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $a4d3843be7f7fab1$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $a4d3843be7f7fab1$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    viewChanges: {
        id: "editor-ellipsis-dropdown.open.ellipsis.view.changes",
        defaultMessage: "View changes"
    },
    resolvedComments: {
        id: "editor-ellipsis-dropdown.open.ellipsis.resolved.comments",
        defaultMessage: "Resolved comments"
    },
    templateImportDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates.and.import",
        defaultMessage: "Templates & import doc"
    },
    more: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more",
        defaultMessage: "More"
    }
});

});


//# sourceMappingURL=EllipsisDropdown.5aec1d59.js.map
